import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { C2Text, C3Text } from "../../../common/components/text/CustomText";
import { Divider, Padding, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import React, { useEffect, useState } from "react";
import DeviceService from "../../../service/DeviceService";
import { TitleAndInput } from "../../../common/components/input/TitleAndInput";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import CustomOptionButton from "../../../common/components/button/CustomOptionButton";
import CustomPopup from "../../../common/components/popup/CustomPopup";
import Translate from "../../../common/translate/Translate";
import DeviceSettingOptionTable from "../components/DeviceSettingOptionTable";
import { Theme } from "../../../common/Theme";

function DeviceSettingModal({ isOpen, onClose, device }) {
    const deviceService = new DeviceService();
    const [selectedUserWashPrice, setSelectedUserWashPrice] = useState(1);
    const [selectedValueOfCoin, setSelectedValueOfCoin] = useState(1);
    const [deviceSettings, setDeviceSettings] = useState(null);

    useEffect(() => {
        if (!device?.id) return;
        deviceService
            .getDeviceSettings({ deviceId: device.id })
            .then((result) => {
                setDeviceSettings(result);
                // TODO: API 연동 시 result 구조에 맞춰 functionOptionData, priceOptionData 등 상태 업데이트 필요
            })
            .catch((error) => {
                console.error("Error fetching device settings:", error);
            });
    }, [device?.id]);

    // Confirm Modal
    const [isConfirmPopupOpen, setIsConfirmPopupOpen] = useState(false);

    const handleConfirmClose = () => {
        setIsConfirmPopupOpen(false);
    };

    const handleConfirmOk = () => {
        const reqDto = {
            userWashPrice: selectedUserWashPrice,
            valueOfCoin: selectedValueOfCoin,
            // TODO: API 연동 시 functionOptionData, priceOptionData 포함 필요
        };
        deviceService
            .saveDeviceSettings({ deviceId: device.id, reqDto })
            .then(() => {
                setIsConfirmPopupOpen(false);
                onClose();
            })
            .catch((error) => {
                console.error("Error saving device settings:", error);
                setIsConfirmPopupOpen(false);
            });
    };

    // 테이블 형태
    let functionOptionColumnHeaders = [];
    let functionOptionRowData = [
        { label: Translate("store.deviceMenu.setting.functionOption.washingTime"), value: "washingTime" },
        { label: Translate("store.deviceMenu.setting.functionOption.waterLevel"), value: "waterLevel" },
        { label: Translate("store.deviceMenu.setting.functionOption.rinsingTime"), value: "rinsingTime" },
        { label: Translate("store.deviceMenu.setting.functionOption.rinsingCount"), value: "rinsingCount" },
        { label: Translate("store.deviceMenu.setting.functionOption.topSpinSpeed"), value: "topSpinSpeed" },
        { label: Translate("store.deviceMenu.setting.functionOption.twinSpray"), value: "twinSpray" },
    ];
    let functionOptionData = [];
    let priceOptionColumnHeaders = [];
    let priceOptionRowData = [];
    let priceOptionData = [];
    let maxWidth = "1100px";
    if (device.dryType === "nonHeater") {
        functionOptionColumnHeaders = [
            { label: "Hot", value: "hot" },
            { label: "Warm", value: "warm" },
            { label: "Cold", value: "cold" },
            { label: "Delicates", value: "delicates" },
        ];
        functionOptionData = [
            { washingTime: 8, waterLevel: "low", rinsingTime: 8, rinsingCount: 1, topSpinSpeed: "Max" },
            { washingTime: 9, waterLevel: "low", rinsingTime: 9, rinsingCount: 2, topSpinSpeed: "1000" },
            { washingTime: 9, waterLevel: "low", rinsingTime: 9, rinsingCount: 3, topSpinSpeed: "900" },
            { washingTime: 9, waterLevel: "low", rinsingTime: 9, rinsingCount: 4, topSpinSpeed: "800" },
        ];
        priceOptionColumnHeaders = [
            { label: "Default", value: "default" },
            { label: "Hot", value: "hot" },
            { label: "Warm", value: "warm" },
            { label: "Cold", value: "cold" },
            { label: "Delicates", value: "delicates" },
        ];
        priceOptionRowData = [
            { label: Translate("store.deviceMenu.setting.priceAndPaymentOption.regularPrice"), value: "regularPrice" },
        ];
        priceOptionData = [
            { regularPrice: 1 },
            { regularPrice: 1 },
            { regularPrice: 1 },
            { regularPrice: 1 },
            { regularPrice: 1 },
        ];
    } else if (device.dryType === "heater") {
        functionOptionColumnHeaders = [
            { label: "90°C(194°F)", value: "90" },
            { label: "75°C(167°F)", value: "75" },
            { label: "60°C(140°F)", value: "60" },
            { label: "40°C(104°F)", value: "40" },
            { label: "30°C(86°F)", value: "30" },
            { label: "Cold", value: "cold" },
        ];
        functionOptionData = [
            { washingTime: 8, waterLevel: "low", rinsingTime: 8, rinsingCount: 1, topSpinSpeed: "Max" },
            { washingTime: 9, waterLevel: "low", rinsingTime: 9, rinsingCount: 2, topSpinSpeed: "1000" },
            { washingTime: 9, waterLevel: "low", rinsingTime: 9, rinsingCount: 3, topSpinSpeed: "900" },
            { washingTime: 9, waterLevel: "low", rinsingTime: 9, rinsingCount: 4, topSpinSpeed: "800" },
            { washingTime: 9, waterLevel: "low", rinsingTime: 9, rinsingCount: 4, topSpinSpeed: "800" },
            { washingTime: 9, waterLevel: "low", rinsingTime: 9, rinsingCount: 4, topSpinSpeed: "800" },
        ];
        priceOptionColumnHeaders = [
            { label: "Default", value: "default" },
            { label: "90°C(194°F)", value: "90" },
            { label: "75°C(167°F)", value: "75" },
            { label: "60°C(140°F)", value: "60" },
            { label: "40°C(104°F)", value: "40" },
            { label: "30°C(86°F)", value: "30" },
            { label: "Cold", value: "cold" },
        ];
        priceOptionRowData = [
            { label: Translate("store.deviceMenu.setting.priceAndPaymentOption.regularPrice"), value: "regularPrice" },
        ];
        priceOptionData = [
            { regularPrice: 1 },
            { regularPrice: 1 },
            { regularPrice: 1 },
            { regularPrice: 1 },
            { regularPrice: 1 },
            { regularPrice: 1 },
            { regularPrice: 1 },
        ];
        maxWidth = "1400px";
    } else if (device.dryType === "dryer") {
        functionOptionColumnHeaders = [
            { label: "High Temp", value: "highTemp" },
            { label: "Med Temp", value: "mediumTemp" },
            { label: "Low Temp", value: "lowTemp" },
            { label: "Extra Dry", value: "extraDry" },
        ];
        functionOptionRowData = [
            { label: Translate("store.deviceMenu.setting.functionOption.dryCycleTime"), value: "dryCycleTime" },
            { label: Translate("store.deviceMenu.setting.functionOption.topOffTime"), value: "topOffTime" },
            { label: Translate("store.deviceMenu.setting.functionOption.topOff"), value: "topOff" },
            { label: Translate("store.deviceMenu.setting.functionOption.sensingDry"), value: "sensingDry" },
        ];
        functionOptionData = [
            { dryCycleTime: 8, topOffTime: 8 },
            { dryCycleTime: 9, topOffTime: 9 },
            { dryCycleTime: 9, topOffTime: 9 },
            { dryCycleTime: 9, topOffTime: 9 },
            { dryCycleTime: 9, topOffTime: 9 },
            { dryCycleTime: 9, topOffTime: 9 },
        ];
        priceOptionColumnHeaders = [
            { label: "Default", value: "default" },
            { label: "High Temp", value: "highTemp" },
            { label: "Med Temp", value: "mediumTemp" },
            { label: "Low Temp", value: "lowTemp" },
            { label: "Extra Dry", value: "extraDry" },
        ];
        priceOptionRowData = [
            { label: Translate("store.deviceMenu.setting.priceAndPaymentOption.regularPrice"), value: "regularPrice" },
            { label: Translate("store.deviceMenu.setting.priceAndPaymentOption.topOffPrice"), value: "topOffPrice" },
        ];
        priceOptionData = [
            { regularPrice: 1, topOffPrice: 1 },
            { regularPrice: 1, topOffPrice: 1 },
            { regularPrice: 1, topOffPrice: 1 },
            { regularPrice: 1, topOffPrice: 1 },
            { regularPrice: 1, topOffPrice: 1 },
            { regularPrice: 1, topOffPrice: 1 },
            { regularPrice: 1, topOffPrice: 1 },
        ];
    }

    // 팝업 메시지
    let popupMessage = "Apply to all Non-Heater Type devices?";
    if (device.dryType === "heater") {
        popupMessage = "Apply to all Heater Type devices?";
    } else if (device.dryType === "dryer") {
        popupMessage = "Apply to all Dryer Type devices?";
    }

    // 세이브 옵션
    const handleSaveThisDeviceOnly = () => {
        const reqDto = {
            userWashPrice: selectedUserWashPrice,
            valueOfCoin: selectedValueOfCoin,
        };
        deviceService
            .saveDeviceSettings({ deviceId: device.id, reqDto })
            .then(() => {
                onClose();
            })
            .catch((error) => {
                console.error("Error saving device settings:", error);
            });
    };

    let saveOptions = [
        {
            label: "This Device Only",
            value: "This Device Only",
            onClick: handleSaveThisDeviceOnly,
        },
    ];
    if (device.dryType === "nonHeater") {
        saveOptions.push({
            label: "All Non-Heater Type",
            value: "All Non-Heater Type",
            onClick: () => setIsConfirmPopupOpen(true),
        });
    } else if (device.dryType === "heater") {
        saveOptions.push({
            label: "All Heater Type",
            value: "All Heater Type",
            onClick: () => setIsConfirmPopupOpen(true),
        });
    } else if (device.dryType === "dryer") {
        saveOptions.push({
            label: "All Dryer Type",
            value: "All Dryer Type",
            onClick: () => setIsConfirmPopupOpen(true),
        });
    }

    return (
        <CustomModal
            title={"Setting"}
            isOpen={isOpen}
            onClose={onClose}
            side={"right"}
            height={"100%"}
            maxWidth={maxWidth}
        >
            <Row>
                <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.type")}</C3Text>
                <SizedBox width={"8px"} />
                <C3Text>{device.type}</C3Text>
                <Divider orientation={"vertical"} height={"16px"} marginLeft={"24px"} marginRight={"12px"} />
                <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.name")}</C3Text>
                <SizedBox width={"8px"} />
                <C3Text>{device.name}</C3Text>
                <Divider orientation={"vertical"} height={"16px"} marginLeft={"24px"} marginRight={"12px"} />
                <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.model")}</C3Text>
                <SizedBox width={"8px"} />
                <C3Text>{device.model}</C3Text>
                <Divider orientation={"vertical"} height={"16px"} marginLeft={"24px"} marginRight={"12px"} />
                <C3Text fontColor={Theme.color.gray500}>{Translate("store.deviceMenu.id")}</C3Text>
                <SizedBox width={"8px"} />
                <C3Text>{device.id}</C3Text>
            </Row>
            <SizedBox height={"20px"} />
            <SizedBox
                width={"100%"}
                height={"auto"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                borderRadius={"12px"}
                border={`1px solid ${Theme.color.gray200}`}
                overflow={"none"}
                padding={"20px 20px 10px 20px"}
            >
                <C2Text fontWeight={"600"}>{Translate("store.deviceMenu.setting.functionOption")}</C2Text>
                <SizedBox height={"12px"} />
                <DeviceSettingOptionTable
                    columnHeaders={functionOptionColumnHeaders}
                    rowData={functionOptionRowData}
                    data={functionOptionData}
                />
            </SizedBox>
            <SizedBox height={"16px"} />
            <SizedBox
                width={"100%"}
                height={"auto"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                borderRadius={"12px"}
                border={`1px solid ${Theme.color.gray200}`}
                overflow={"none"}
                padding={"20px 20px 10px 20px"}
            >
                <C2Text fontWeight={"600"}>
                    {Translate("store.deviceMenu.setting.priceAndPaymentOption")} (THB, ฿)
                </C2Text>
                <SizedBox height={"12px"} />
                <DeviceSettingOptionTable
                    columnHeaders={priceOptionColumnHeaders}
                    rowData={priceOptionRowData}
                    data={priceOptionData}
                />
            </SizedBox>
            <SizedBox height={"16px"} />
            <SizedBox
                width={"100%"}
                height={"auto"}
                alignItem={"flex-start"}
                justifyContent={"flex-start"}
                borderRadius={"12px"}
                border={`1px solid ${Theme.color.gray200}`}
                overflow={"none"}
                padding={"20px 20px 20px 30px"}
            >
                <Row>
                    {(device.dryType === "nonHeater" || device.dryType === "heater") && (
                        <>
                            <Row>
                                <TitleAndInput
                                    type={"select"}
                                    title={Translate("store.deviceMenu.setting.userWashPrice")}
                                    dropdownValues={[
                                        { label: "0", value: 0 },
                                        { label: "1", value: 1 },
                                        { label: "2", value: 2 },
                                    ]}
                                    inputValue={selectedUserWashPrice}
                                    setInputValue={setSelectedUserWashPrice}
                                />
                            </Row>
                            <SizedBox width={"30px"} />
                        </>
                    )}
                    {(device.dryType === "nonHeater" || device.dryType === "dryer") && (
                        <Row>
                            <TitleAndInput
                                type={"select"}
                                title={Translate("store.deviceMenu.setting.valueOfCoin1")}
                                dropdownValues={[
                                    { label: "0", value: 0 },
                                    { label: "1", value: 1 },
                                    { label: "2", value: 2 },
                                ]}
                                inputValue={selectedValueOfCoin}
                                setInputValue={setSelectedValueOfCoin}
                            />
                        </Row>
                    )}
                </Row>
            </SizedBox>
            <SizedBox height={"10px"} width={"100%"} />
            <Padding padding={"0 30px"}>
                <C3Text fontColor={Theme.color.gray500}>
                    *Default : to apply default prices to all courses, you must set all individual course prices to 0.
                </C3Text>
            </Padding>
            <SizedBox height={"100px"} width={"100%"} />
            <Row justifyContent={"flex-end"} alignItem={"flex-end"} width={"100%"}>
                <SecondaryButton text={"Close"} width={"70px"} onClick={onClose} />
                <SizedBox width={"12px"} />
                <CustomOptionButton isPrimary={true} text={"Save"} width={"70px"} dropdownValues={saveOptions} />
            </Row>
            <CustomPopup
                isOpen={isConfirmPopupOpen}
                onClose={handleConfirmClose}
                onConfirm={handleConfirmOk}
                message={popupMessage}
            />
        </CustomModal>
    );
}

export default DeviceSettingModal;
